export const IDTEL_DATA = [
  {
    "micro": "MICRODOMINIO FONOLÓGICO",
    "domains": [
      {
        "name": "Reconocimiento prosódico",
        "count": 10
      },
      {
        "name": "Adición silábica",
        "count": 15
      },
      {
        "name": "Inversión silábica",
        "count": 15
      },
      {
        "name": "Unión de fonemas",
        "count": 15
      }
    ]
  },
  {
    "micro": "MICRODOMINIO MORFOSINTÁCTICO",
    "domains": [
      {
        "name": "Ejercicio de modelado",
        "count": 15
      },
      {
        "name": "Sufijación de profesiones",
        "count": 11
      },
      {
        "name": "Sufijación de aumentativos",
        "count": 15
      }
    ]
  },
  {
    "micro": "MICRODOMINIO SEMÁNTICO",
    "domains": [
      {
        "name": "Relación atributiva",
        "count": 14
      },
      {
        "name": "Relación funcional",
        "count": 7
      },
      {
        "name": "Relación de metonimia",
        "count": 15
      }
    ]
  },
  {
    "micro": "MICRODOMINIO SEMÁNTICO",
    "domains": [
      {
        "name": "Formación de conceptos",
        "count": 12
      },
      {
        "name": "Reconocimiento de conceptos",
        "count": 12
      },
      {
        "name": "Razonamiento inferencial",
        "count": 9
      }
    ]
  },
  {
    "micro": "MICRODOMINIO PRAGMÁTICO",
    "domains": [
      {
        "name": "Frases hechas",
        "count": 10
      },
      {
        "name": "Ironías",
        "count": 10
      }
    ]
  }
];
